import { render, staticRenderFns } from "./EditSettings.vue?vue&type=template&id=db3a9b9c&scoped=true"
import script from "./EditSettings.vue?vue&type=script&lang=js"
export * from "./EditSettings.vue?vue&type=script&lang=js"
import style0 from "./EditSettings.vue?vue&type=style&index=0&id=db3a9b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a9b9c",
  null
  
)

export default component.exports